import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=a0f568bc&scoped=true"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=a0f568bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f568bc",
  null
  
)

export default component.exports